module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_c('header', [_c('Topbar')], 1), _vm._v(" "), _c('main', [_c('ResumeEditor'), _vm._v(" "), _c('ResumePreview')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6b29584"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 83
// module chunks = 1